import { useNavigate } from '@exam-center/router';
import { BusinessOutlinedIcon, Button, NoRowsOverlay } from '@shared/components';
import { useCallback } from 'react';

export default function NotFoundPage() {
  const navigate = useNavigate();

  const handleBackToHome = useCallback(() => {
    navigate('/');
  }, [navigate]);

  return (
    <NoRowsOverlay
      title='ไม่พบศูนย์ทดสอบนี้ในระบบ'
      description={`อาจเป็นเพราะลิงก์ไม่ถูกต้อง หรือศูนย์ทดสอบนี้ไม่มีอยู่ในระบบ\nกรุณาตรวจสอบลิงก์อีกครั้ง หรือกลับสู่หน้าหลัก`}
      action={<Button onClick={handleBackToHome}>กลับสู่หน้าหลัก</Button>}
      icon={BusinessOutlinedIcon}
    />
  );
}
